import { useSession } from "@portal/auth/client/SessionProvider";
import useImpersonatedUser from "../useImpersonatedUser";
import { IUseAdvisor } from "./types";
import { isAdvisor } from "@portal/helpers/session/portalRoleStrings";

const useAdvisor: IUseAdvisor = () => {
  const { session } = useSession();
  const { data: impersonatedUser, isLoading } = useImpersonatedUser();
  const isAdvisorBool = isAdvisor(session?.role);

  const isAdvisorAndNoImpersonation = isAdvisorBool && !impersonatedUser?.customerNumber;

  return {
    isAdvisor: isAdvisorBool,
    isAdvisorAndNoImpersonation,
    impersonatedCustomerNumber: impersonatedUser?.customerNumber,
    isLoading: session?.status === "loading" || isLoading,
  };
};

export default useAdvisor;
